export const EmiCalcualtorsLinks = [
  {
    id: 1,
    calculatorName: "Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-emi-1738049877060.webp",
    link: "/calculators/emi-calculators/personal-loan-emi-calculator",
  },
  {
    id: 2,
    calculatorName: "Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-emi-1738049750722.webp",
    link: "/calculators/emi-calculators/home-loan-emi-calculator",
  },
  {
    id: 3,
    calculatorName: "Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-loan-emi-1738049938014.webp",
    link: "/calculators/emi-calculators/car-loan-emi-calculator",
  },
  {
    id: 4,
    calculatorName: "Credit Card Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-loan-emi-1738050079311.webp",
    link: "/calculators/emi-calculators/credit-card-loan-emi-calculator",
  },
  {
    id: 5,
    calculatorName: "Axis Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/axis-loan-emi-1738126798853.webp",
    link: "/calculators/emi-calculators/axis-bank-personal-loan-emi-calculator",
  },
  {
    id: 6,
    calculatorName: "Axis Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/axis-loan-emi-1738126798853.webp",
    link: "/calculators/emi-calculators/axis-bank-home-loan-emi-calculator",
  },
  {
    id: 7,
    calculatorName: "Axis Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/axis-loan-emi-1738126798853.webp",
    link: "/calculators/emi-calculators/axis-bank-car-loan-emi-calculator",
  },
  {
    id: 8,
    calculatorName: "SBI Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/sbi-loan-emi-1738126578338.webp",
    link: "/calculators/emi-calculators/sbi-personal-loan-emi-calculator",
  },
  {
    id: 9,
    calculatorName: "SBI Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/sbi-loan-emi-1738126578338.webp",
    link: "/calculators/emi-calculators/sbi-home-loan-emi-calculator",
  },
  {
    id: 10,
    calculatorName: "SBI Loan Car EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/sbi-loan-emi-1738126578338.webp",
    link: "/calculators/emi-calculators/sbi-car-loan-emi-calculator",
  },

  {
    id: 11,
    calculatorName: "HDFC Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/hdfc-loan-emi-1738126887506.webp",
    link: "/calculators/emi-calculators/hdfc-personal-loan-emi-calculator",
  },

  {
    id: 12,
    calculatorName: "HDFC Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/hdfc-loan-emi-1738126887506.webp",
    link: "/calculators/emi-calculators/hdfc-home-loan-emi-calculator",
  },

  {
    id: 13,
    calculatorName: "HDFC Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/hdfc-loan-emi-1738126887506.webp",
    link: "/calculators/emi-calculators/hdfc-car-loan-emi-calculator",
  },
  {
    id: 14,
    calculatorName: "ICICI Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/icici-personal-loan-emi-calculator",
  },
  {
    id: 15,
    calculatorName: "ICICI Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/icici-home-loan-emi-calculator",
  },
  {
    id: 16,
    calculatorName: "ICICI Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/icici-car-loan-emi-calculator",
  },
  {
    id: 17,
    calculatorName: "Indian Overseas Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/indian-overseas-bank-personal-loan-emi-calculator",
  },
  {
    id: 18,
    calculatorName: "Indian Overseas Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/indian-overseas-bank-home-loan-emi-calculator",
  },
  {
    id: 19,
    calculatorName: "Kotak Mahindra Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/kotak-mahindra-personal-loan-emi-calculator",
  },
  {
    id: 20,
    calculatorName: "Kotak Mahindra Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/kotak-mahindra-home-loan-emi-calculator",
  },
  {
    id: 21,
    calculatorName: "Kotak Mahindra Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/kotak-mahindra-car-loan-emi-calculator",
  },
  {
    id: 22,
    calculatorName: "Bank of Baroda Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/bank-of-baroda-personal-loan-emi-calculator",
  },
  {
    id: 23,
    calculatorName: "Bank of Baroda Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/bank-of-baroda-home-loan-emi-calculator",
  },
  {
    id: 24,
    calculatorName: "Bank of Baroda Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/bank-of-baroda-car-loan-emi-calculator",
  },
  {
    id: 25,
    calculatorName: "IndusInd Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/indusind-bank-personal-loan-emi-calculator",
  },
  {
    id: 26,
    calculatorName: "IndusInd Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/indusind-bank-home-loan-emi-calculator",
  },
  {
    id: 27,
    calculatorName: "IndusInd Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/indusind-bank-car-loan-emi-calculator",
  },
  {
    id: 28,
    calculatorName: "Canara Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/canara-bank-personal-loan-emi-calculator",
  },
  {
    id: 29,
    calculatorName: "Canara Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/canara-bank-home-loan-emi-calculator",
  },
  {
    id: 30,
    calculatorName: "Canara Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/canara-bank-car-loan-emi-calculator",
  },
  {
    id: 31,
    calculatorName: "Punjab National Bank Personal Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/punjab-national-bank-personal-loan-emi-calculator",
  },
  {
    id: 32,
    calculatorName: "Punjab National Bank Home Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/punjab-national-bank-home-loan-emi-calculator",
  },
  {
    id: 33,
    calculatorName: "Punjab National Bank Car Loan EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/icici-loan-emi-1738126935919.webp",
    link: "/calculators/emi-calculators/punjab-national-bank-car-loan-emi-calculator",
  },
];

export const EligibilityLinks = [
  {
    id: 1,
    calculatorName: "Personal Loan Eligibility Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-eligibility-1738408950424.webp",
    link: "/calculators/eligibility-calculators/personal-loan-eligibility-calculator",
  },
  {
    id: 2,
    calculatorName: "Car Loan Eligibility Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-loan-eligibility-1738406086555.webp",
    link: "/calculators/eligibility-calculators/car-loan-eligibility-calculator",
  },
  {
    id: 3,
    calculatorName: "Home Loan Eligibility Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-eligibility-1738835920818.webp",
    link: "/calculators/eligibility-calculators/home-loan-eligibility-calculator",
  },
];

export const ConsolidationLinks = [
  {
    id: 1,
    calculatorName: "Debt Consolidation Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/debt-consolidation-1738049469538.webp",
    link: "/calculators/debt-consolidation-calculators/debt-consolidation-calculator",
  },
  {
    id: 2,
    calculatorName: "Personal Loan Debt Consolidation Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-debt-consolidation-1738050351654.webp",
    link: "/calculators/debt-consolidation-calculators/debt-consolidation-for-personal-loan-calculator",
  },
];

export const RefinancingLinks = [
  {
    id: 1,
    calculatorName: "Personal Loan Refinance Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-refinancing-1738391113368.webp",
    link: "/calculators/refinancing-calculators/refinancing-personal-loan-calculator",
  },
  {
    id: 2,
    calculatorName: "Car Loan Refinancing Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/refinance-auto-loan-1738390834573.webp",
    link: "/calculators/refinancing-calculators/refinancing-car-loan-calculator",
  },
];

export const BalanceTransferLinks = [
  {
    id: 1,
    calculatorName: "Personal Loan Balance Transfer EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/ptbt-1738411759551.webp",
    link: "/calculators/balance-transfer-calculators/personal-loan-balance-transfer-calculator",
  },
  {
    id: 2,
    calculatorName: "Home Loan Balance Transfer EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/htbt-1738411892022.webp",
    link: "/calculators/balance-transfer-calculators/home-loan-balance-transfer-calculator",
  },
  {
    id: 3,
    calculatorName: "Car Loan Balance Transfer EMI Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/ctbt-1738414538742.webp",
    link: "/calculators/balance-transfer-calculators/car-loan-balance-transfer-calculator",
  },
];

export const FinancialResourcesLinks = [
  {
    id: 1,
    calculatorName: "What Is a Balance Transfer",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/What-credit-card-1738391819861.webp",
    link: "/calculators/financial-insights-and-tools/what-is-balance-transfer-blog",
  },
  {
    id: 2,
    calculatorName: "Personal Loan Balance Transfer with MinEMI",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-bt-loan-1738393201640.webp",
    link: "/calculators/financial-insights-and-tools/personal-loan-balance-transfer-blog",
  },
  {
    id: 3,
    calculatorName: "Home Loan Balance Transfer with MinEMI",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/home-loan-1737028012223.webp",
    link: "/calculators/financial-insights-and-tools/home-loan-balance-transfer-blog",
  },
  {
    id: 4,
    calculatorName: "Car Loan Balance Transfer with MinEMI",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/car-bt-loan-1738393420849.webp",
    link: "/calculators/financial-insights-and-tools/car-loan-balance-transfer-blog",
  },
  {
    id: 5,
    calculatorName: "Credit Card Balance Transfer Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/credit-card-1737027764144.webp",
    link: "/calculators/financial-insights-and-tools/credit-card-balance-transfer-blog",
  },
];
